import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useSelector } from "react-redux";
import Linkify from "~/components/Linkify";
import { BOARD_COLLECTION_DESCRIPTION, BOARD_COLLECTION_TITLE } from "~/constants/testIDs";
import { boardCollectionFormSelector } from "~/store/boardCollection/selectors";
import { BoardCollectionRequiredFields } from "./BoardCollectionRequiredFields";
export const BoardCollectionHeader = /*#__PURE__*/ memo(()=>{
    const form = useSelector(boardCollectionFormSelector);
    return /*#__PURE__*/ _jsxs("header", {
        className: "px-1 pb-12 lg:px-2",
        children: [
            !!(form === null || form === void 0 ? void 0 : form.title) && /*#__PURE__*/ _jsx("h1", {
                className: "m-0 mb-2.5 text-24 font-semibold text-pigeon-600",
                "data-testid": BOARD_COLLECTION_TITLE,
                children: form.title
            }),
            !!(form === null || form === void 0 ? void 0 : form.description) && /*#__PURE__*/ _jsx(Linkify, {
                children: /*#__PURE__*/ _jsx("p", {
                    className: "whitespace-pre-wrap break-words text-14 text-pigeon-600",
                    "data-testid": BOARD_COLLECTION_DESCRIPTION,
                    children: form.description
                })
            }),
            /*#__PURE__*/ _jsx(BoardCollectionRequiredFields, {})
        ]
    });
});
BoardCollectionHeader.displayName = "BoardCollectionHeader";
